<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1005_61628)">
      <path
        d="M1.33338 7.99991C1.33306 8.12742 1.36932 8.25235 1.43785 8.35988C1.50639 8.46741 1.60432 8.55302 1.72004 8.60658L7.45338 11.2132C7.62618 11.2915 7.81368 11.332 8.00338 11.332C8.19307 11.332 8.38058 11.2915 8.55338 11.2132L14.2734 8.61325C14.3914 8.56021 14.4914 8.47397 14.5612 8.36507C14.6311 8.25616 14.6677 8.12929 14.6667 7.99991M1.33338 11.3332C1.33306 11.4608 1.36932 11.5857 1.43785 11.6932C1.50639 11.8007 1.60432 11.8864 1.72004 11.9399L7.45338 14.5466C7.62618 14.6248 7.81368 14.6653 8.00338 14.6653C8.19307 14.6653 8.38058 14.6248 8.55338 14.5466L14.2734 11.9466C14.3914 11.8935 14.4914 11.8073 14.5612 11.6984C14.6311 11.5895 14.6677 11.4626 14.6667 11.3332M8.55338 1.45325C8.37967 1.37401 8.19097 1.33301 8.00004 1.33301C7.80912 1.33301 7.62042 1.37401 7.44671 1.45325L1.73338 4.05325C1.61508 4.10541 1.5145 4.19084 1.44388 4.29915C1.37327 4.40746 1.33568 4.53396 1.33568 4.66325C1.33568 4.79254 1.37327 4.91904 1.44388 5.02734C1.5145 5.13565 1.61508 5.22108 1.73338 5.27325L7.45338 7.87991C7.62708 7.95915 7.81578 8.00015 8.00671 8.00015C8.19764 8.00015 8.38633 7.95915 8.56004 7.87991L14.28 5.27991C14.3983 5.22775 14.4989 5.14231 14.5695 5.03401C14.6401 4.9257 14.6777 4.7992 14.6777 4.66991C14.6777 4.54062 14.6401 4.41412 14.5695 4.30582C14.4989 4.19751 14.3983 4.11208 14.28 4.05991L8.55338 1.45325Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1005_61628">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
